import React from 'react'

import EntitySelection from '../../components/EntitySelection'
import { AccommodationDataWithRatePlans } from '../../types/accommodation'
import { ContractInput } from '../../types/contract'

interface ContractFormStepTwoProps {
  contract: ContractInput
  setcontract: (c: ContractInput) => void
  loadingForContract: boolean
  accommodationsData: AccommodationDataWithRatePlans[]
  setAccommodationsData: React.Dispatch<
    React.SetStateAction<AccommodationDataWithRatePlans[]>
  >
  providerCodeForGenerate: string
  isRoleAccommodation: boolean
}

export const ContractFormStepTwo: React.FC<ContractFormStepTwoProps> = ({
  contract,
  setcontract,
  loadingForContract,
  accommodationsData,
  setAccommodationsData,
  providerCodeForGenerate,
  isRoleAccommodation
}) => {
  return (
    <div>
      <EntitySelection
        loadingForContract={loadingForContract}
        contract={contract}
        setcontract={setcontract}
        accommodationsData={accommodationsData}
        setAccommodationsData={setAccommodationsData}
        providerCodeForGenerate={providerCodeForGenerate}
        isRoleAccommodation={isRoleAccommodation}
      />
    </div>
  )
}
